import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import DropDoc from '../../../shared/components/form/DropDoc';

const FormCompany = (props) => {
  const {
    data, removeDoc, addDocument, documents, isViewOnly, setDocument,
  } = props;
  const { isLoading, category, subcategory } = data;

    return (
      <div>
        {
          isViewOnly ? (
            <div className="form__form-group">
              {
                documents.length > 0 ? (
                  documents.map(e => (
                    <div key={e.fullPath} className="ellipsis">
                      <Button className="blueish" color="link" onClick={() => setDocument(e)}>{e.name}</Button>
                    </div>
                  ))
                ) : (
                  <div>
                    Aucun document rattaché.
                  </div>
                )
              }
            </div>
          ) : (
            <div className="form__form-group">
              <div className="form__form-group-field">
                <DropDoc value={documents} onRemove={removeDoc} onChange={addDocument} disabled={isLoading} />
              </div>
              <div className="form__form-group-sublabel mt-10">
                {
                  category === 'company' || subcategory === 'sci' ? 'Ex: Immatriculation, Kbis, status, etc' : 'Ex: Acte notarié, titre de propriété etc'
                }
              </div>
            </div>
          )
        }
      </div>
    );
};

FormCompany.propTypes = {
  data: PropTypes.shape({}).isRequired,
  removeDoc: PropTypes.func,
  addDocument: PropTypes.func,
  documents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setDocument: PropTypes.func.isRequired,
  isViewOnly: PropTypes.bool.isRequired,
};

FormCompany.defaultProps = {
  removeDoc: () => {},
  addDocument: () => {},
};

export default FormCompany;
